import React from 'react';

const DashboardCard = ({ icon, title, description, onClick, delay = 0 }) => {
  return (
    <div
      className="dashboard-card animate-card"
      style={{ animationDelay: `${delay}ms` }}
      onClick={onClick}
    >
      <div className="dashboard-card-icon">
        {icon}
      </div>
      <div className="dashboard-card-content">
        <h6>{title}</h6>
        <p>{description}</p>
      </div>
    </div>
  );
};


export default DashboardCard;
